import React from 'react';
import { createIcon } from './create-icon';
import './icon-chevron-right.scss';

export const IconChevronRight = createIcon(<div className="icon-chevron-right" />);
